import './App.css';
import { ShowroomPage } from './features/showroom/components/ShowroomPage';

function App() {
  return <ShowroomPage />;
}

export default App;
